var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgWalletOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.75554C0 2.54052 0.984974 1.55554 2.2 1.55554H11.8C13.015 1.55554 14 2.54052 14 3.75554V4.35554V9.55554V10.1555C14 11.3706 13.015 12.3555 11.8 12.3555H2.2C0.984974 12.3555 0 11.3706 0 10.1555V3.75554ZM12.8 3.75554V4.35554H8.6C7.8268 4.35554 7.2 4.98234 7.2 5.75554V8.15554C7.2 8.92874 7.8268 9.55554 8.6 9.55554H12.8V10.1555C12.8 10.7078 12.3523 11.1555 11.8 11.1555H2.2C1.64772 11.1555 1.2 10.7078 1.2 10.1555V3.75554C1.2 3.20326 1.64772 2.75554 2.2 2.75554H11.8C12.3523 2.75554 12.8 3.20326 12.8 3.75554ZM12.8 5.55554V8.35554H8.6C8.48954 8.35554 8.4 8.266 8.4 8.15554V5.75554C8.4 5.64509 8.48954 5.55554 8.6 5.55554H12.8ZM9.8 7.71554C10.2418 7.71554 10.6 7.35737 10.6 6.91554C10.6 6.47371 10.2418 6.11554 9.8 6.11554C9.35817 6.11554 9 6.47371 9 6.91554C9 7.35737 9.35817 7.71554 9.8 7.71554Z",
    fill: "var(--secondary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletOutlined);
export default __webpack_public_path__ + "static/media/walletOutlined.3b3fa04fa75fb71b1932a79cdcd75563.svg";
export { ForwardRef as ReactComponent };